// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-color);
  background-color: var(--bg-primary);
  gap: 12px;
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(12px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* In header layout, stick below fixed top header */
.App.header-layout .sidebar-header-bar {
  top: 60px;
}

.sidebar-header-bar .menu-open-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: background-color 0.2s;
  flex-shrink: 0;
  position: relative;
}

.sidebar-header-bar .menu-open-btn:hover {
  background: var(--hover-bg);
}

.sidebar-header-bar .menu-open-btn svg {
  width: 24px;
  height: 24px;
}

.sidebar-header-bar .menu-open-btn.left-toggle {
  margin-right: auto;
}

.sidebar-header-bar .menu-open-btn.right-toggle {
  margin-left: auto;
}

.sidebar-header-badge {
  position: absolute;
  top: -3px;
  right: -3px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--accent-primary);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}

.sidebar-header-bar .header-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 1.3rem 0;
  flex: 0 1 auto;
  text-align: center;
}

/* Hide right toggle on desktop since sidebar is visible */
@media (min-width: 768.7px) {
  .sidebar-header-bar .menu-open-btn.right-toggle,
  .sidebar-header-bar .menu-open-btn.left-toggle {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SidebarHeader/SidebarHeader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,mCAAmC;EACnC,SAAS;EACT,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,mDAAmD;AACnD;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,0DAA0D;AAC1D;EACE;;IAEE,wBAAwB;EAC1B;AACF","sourcesContent":[".sidebar-header-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 16px 20px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  background-color: var(--bg-primary);\r\n  gap: 12px;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 100;\r\n  backdrop-filter: blur(12px);\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* In header layout, stick below fixed top header */\r\n.App.header-layout .sidebar-header-bar {\r\n  top: 60px;\r\n}\r\n\r\n.sidebar-header-bar .menu-open-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  transition: background-color 0.2s;\r\n  flex-shrink: 0;\r\n  position: relative;\r\n}\r\n\r\n.sidebar-header-bar .menu-open-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.sidebar-header-bar .menu-open-btn svg {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n.sidebar-header-bar .menu-open-btn.left-toggle {\r\n  margin-right: auto;\r\n}\r\n\r\n.sidebar-header-bar .menu-open-btn.right-toggle {\r\n  margin-left: auto;\r\n}\r\n\r\n.sidebar-header-badge {\r\n  position: absolute;\r\n  top: -3px;\r\n  right: -3px;\r\n  min-width: 18px;\r\n  height: 18px;\r\n  padding: 0 5px;\r\n  border-radius: 999px;\r\n  background: var(--accent-primary);\r\n  color: #fff;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  line-height: 18px;\r\n  text-align: center;\r\n}\r\n\r\n.sidebar-header-bar .header-title {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 1.3rem 0;\r\n  flex: 0 1 auto;\r\n  text-align: center;\r\n}\r\n\r\n/* Hide right toggle on desktop since sidebar is visible */\r\n@media (min-width: 768.7px) {\r\n  .sidebar-header-bar .menu-open-btn.right-toggle,\r\n  .sidebar-header-bar .menu-open-btn.left-toggle {\r\n    display: none !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
